<template>
  <div class="upload-idx">
    <van-cell-group>
      <template #title>
        <div style="text-align: left;">上传资料</div>
      </template>
      <err-tip domId="person_photo" :errmsg="errMsg.person_photo" v-if="showPic">
        <van-field
          v-model="form.person_photo"
          label="个人影像"
          placeholder="未添加"
          readonly
          input-align="right"
          right-icon="arrow"
          @click="link('upload_picture')"
        />
      </err-tip>
      <err-tip domId="id_photo" :errmsg="errMsg.id_photo">
        <van-field
          v-model="form.id_photo"
          label="身份证件"
          placeholder="未添加"
          input-align="right"
          readonly
          right-icon="arrow"
          @click="link('upload_id')"
        />
      </err-tip>
      <err-tip domId="address_info" :errmsg="errMsg.address_info" v-if="isCnId">
        <van-field
          v-model="form.address_info"
          label="住址"
          readonly
          input-align="right"
          right-icon="arrow"
          @click="showSheet"
        />
      </err-tip>
      <err-tip domId="addr_photo" :errmsg="errMsg.addr_photo" v-if="form.address_info === '上传证明' || !isCnId">
        <van-field
          v-model="form.addr_photo"
          label="住址证明"
          placeholder="未添加"
          readonly
          input-align="right"
          right-icon="arrow"
          @click="link('upload_adress')"
        />
      </err-tip>
      <err-tip domId="bank_photo" :errmsg="errMsg.bank_photo">
        <van-field
          v-model="form.bank_photo"
          label="银行证明"
          placeholder="未添加"
          input-align="right"
          readonly
          right-icon="arrow"
          @click="link('upload_bank')"
        />
      </err-tip>
      <err-tip domId="asset_photo" :errmsg="errMsg.asset_photo" v-if="showAssess">
        <van-field
          v-model="form.asset_photo"
          label="个人资产证明"
          input-align="right"
          placeholder="未添加"
          readonly
          right-icon="arrow"
          @click="link('upload_assets')"
        />
      </err-tip>
      <err-tip domId="transfer_photo" :errmsg="errMsg.transfer_photo" v-if="showPic">
        <van-field
          v-model="form.transfer_photo"
          input-align="right"
          label="转账记录"
          label-width="5em"
          placeholder="未添加（添加后可加快审批）"
          readonly
          right-icon="arrow"
          @click="link('upload_transfer')"
        />
      </err-tip>
    </van-cell-group>
    <van-action-sheet
      v-model:show="isShowSheet"
      :actions="actions"
      @select="onSheetSelect"
      cancel-text="取消"
      close-on-click-action
    />
    <div style="width: 100%;text-align: center;">
      <van-button type="primary" class="btn" @click="next">
        提交
      </van-button>
      <van-button class="btn" @click="before">
        上一步
      </van-button>
    </div>
  </div>
</template>

<script>
import {
  Button, CellGroup, Cell, Field, ActionSheet, Toast,
} from 'vant';
import { useStore } from 'vuex';
import {
  onMounted, ref, reactive, watch,
} from 'vue';
import httpApi from '../../utils/httpApi';
import ErrTip from '../ErrTip.vue';

let submitForm = {};

export default {
  name: 'Home',
  components: {
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [ActionSheet.name]: ActionSheet,
    ErrTip,
  },
  data() {
    return {
      isShowSheet: false,
      actions: [{ name: '同身份证住址' }, { name: '上传证明' }],
      errMsg: {
        person_photo: '',
        id_photo: '',
        address_info: '',
        addr_photo: '',
        bank_photo: '',
        asset_photo: '',
        transfer_photo: '',
      },
    };
  },
  methods: {
    showSheet() {
      this.isShowSheet = true;
    },
    async onSheetSelect(value) {
      this.form.address_info = value.name;
      this.errMsg.address_info = '';
      this.errMsg.addr_photo = '';
      await httpApi.submitAddressInfo({ address: value.name });
      this.isShowSheet = false;
    },
    link(name) {
      this.$router.push({ name });
    },
    async next() {
      const errData = { ...this.errMsg };
      // 清空所有错误信息
      Object.keys(errData).forEach(key => {
        errData[key] = '';
      });

      // 必填字段验证
      if (this.showPic && !submitForm.person_photo) {
        errData.person_photo = '请上传个人影像';
      }

      if (!submitForm.id_photo) {
        errData.id_photo = '请上传身份证件';
      }

      if (this.isCnId && !submitForm.address_info) {
        errData.address_info = '请选择住址类型';
      }

      // 住址证明验证
      if ((submitForm.address_info === '上传证明' || !this.isCnId) && !submitForm.addr_photo) {
        errData.addr_photo = '请上传住址证明';
      }

      if (!submitForm.bank_photo) {
        errData.bank_photo = '请上传银行证明';
      }

      if (this.showAssess && !submitForm.asset_photo) {
        errData.asset_photo = '请上传个人资产证明';
      }

      if (!this.isTransfer) {
        errData.transfer_photo = '请勾选转账退款说明';
      }
      // 检查是否有错误
      const errorFields = Object.keys(errData).filter(key => errData[key]);
      if (errorFields.length > 0) {
        const firstErrorField = errorFields[0];
        const targetEle = document.getElementById(firstErrorField);
        if (targetEle) {
          let scrollY = 0;
          document.querySelectorAll('*').forEach((el) => {
            if (el.scrollTop > 0) scrollY = el.scrollTop;
          });
          const offsetTop = targetEle.getBoundingClientRect().top + scrollY - 200;
          document.getElementById('app').scrollTo({ top: offsetTop, behavior: 'instant' });
        }
        this.errMsg = errData;
        return;
      }

      // 提交数据
      try {
        const res = await this.$api.getAccountSubmit();
        if (res && res.code === 200) {
          Toast.success('提交成功');
          this.$router.push({ path: '/upload/result' });
        } else {
          Toast.fail(res?.msg || '提交失败');
        }
      } catch (error) {
        Toast.fail('提交失败，请重试');
      }
    },
    before() {
      this.$router.go(-1);
    },
  },
  setup() {
    const showPic = ref(false);
    const showAssess = ref(false);
    const isCnId = ref('');
    const isTransfer = ref('');
    const form = reactive({
      major_invester: '',
      type: '',
      person_photo: '',
      id_photo: '',
      addr_photo: '',
      bank_photo: '',
      asset_photo: '',
      transfer_photo: '',
      address_info: '',
    });

    onMounted(async () => {
      const store = useStore();
      store.commit('setTitleValue', '上传资料');
      store.commit('setStepsValue', ['填写资料', '风险认知', '提交资料(2/2)']);
      store.commit('setStepsActive', 2);
      const res1 = await httpApi.getUploadImgesStatus();
      if (!res1) return;
      Object.getOwnPropertyNames(form).forEach((item) => {
        if (item === 'address_info') {
          form[item] = res1.data[item] || '';
        } else if (res1.data[item] !== undefined) {
          form[item] = res1.data[item] ? '已添加' : '';
        }
      });
      const isTrans = await httpApi.getSubmitTransfer();
      if (isTrans) {
        isTransfer.value = isTrans.data.agreeTransfer;
      }
      showAssess.value = res1.data.major_invester === '是';
      showPic.value = res1.data.auth_type === '香港/合资格银行';

      // 判断是否是中国大陆身份证
      const info = await httpApi.getOpenAccountInfo();
      if (info) {
        const isCnIdType = (info.data.type === '中国大陆身份证');
        isCnId.value = isCnIdType;
        // 中国大陆默认同身份证住址，其他情况重置为上传证明
        if (isCnId.value) {
          if (!form.address_info) {
            await httpApi.submitAddressInfo({ address: '同身份证住址' });
            form.address_info = '同身份证住址';
          }
        } else {
          await httpApi.submitAddressInfo({ address: '上传证明' });
        }
      }
    });
    watch(() => form, (newVal) => {
      submitForm = { ...newVal };
    }, { deep: true });
    return {
      isCnId,
      showPic,
      form,
      showAssess,
      isTransfer,
    };
  },
};
</script>

<style lang="less">
.upload-idx {
  .btn {
    width: 80%;
    margin: @space-0 auto;
    margin-bottom: 0;
  }
}
</style>
